import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import * as actionCreators from "../../../action/index.js";
import Pdf from '../../Pdf/Pdf';
import ReactToPrint from "react-to-print";
import AnimButton from '../../Button/AnimButton.js';
class ComponentToPrint extends Component {
  render() {
    return (
      <Pdf/>
    );
  }
}
class PrintAlertBox extends React.Component {

//   constructor(props){
//     super(props);
//     // this.handleShow = this.handleShow.bind(this);
//     // this.handleClose = this.handleClose.bind(this);
//     console.log("HiteshVeshnav",this.props)
    
//     this.state = {
//         show: this.props.isShowAlert,
//         message: this.props.message,
//         alertUsedFor: this.props.alertUsedFor
//     }
// }

handleClose = (alertUsedFor, iSDone) => {    
  this.props.const_var.submitCheckoutBtn = false;
  if (iSDone == true) {    
    this.props.alertDone(this.props.alertUsedFor)
  }else {    
    this.props.alertCancel(this.props.alertUsedFor)
  }  
  // this.setState({ show: false });
  
}
CloseModalBox = ()=>{
  this.props.genratePrintImages(false);
  this.props.const_var.PrintAlertBox = false;
}

render() {
  let style;

  if (window.screen.availWidth < 500) {
    style = {'padding': '40px 20px'};
  }
     
    return (
       <div>


        <Modal centered show={this.props.const_var.PrintAlertBox} dialogClassName="alert-modal react-modal" backdrop='static' keyboard={false} onHide={this.props.CloseModalBox}>            
            <Modal.Body  style={style}>
              <h6 className="big-font">PLEASE WAIT</h6>
                <div className="row">
                  <div className="col-12">
                    <p className="mb-3 mt-3 roboto-medium">Hey! We’ll take pictures of this building to print in your quote. It’s nice to be on the same page. Please don’t refresh the page or go back, It won’t take long.</p>
                    <p className="mb-0 roboto-bold text-uppercase">Thank You for your patience!!</p>
                  </div>
                </div>

                 <div className="alert-footer"> 
                  <ReactToPrint
                    trigger={() => <a style={{ display: (this.props.const_var.PrintAlertBoxShowButton==true)?'inline':"none" }} className="btn btn-secondary text-uppercase mw-100" >               
                    <span className="text">Print</span></a>}
                    content={() => this.componentRef}
                    onBeforePrint={()=>this.CloseModalBox()}
                  />
                  <div style={{ display: "none" }}><ComponentToPrint ref={el => (this.componentRef = el)} /></div>
                 
          </div>
          </Modal.Body>       
         
        </Modal>


          
      </div>
    )
  }
}

const mapStoreToProps = (state) => {
  return state.reducer
}

export default connect(
  mapStoreToProps,
  actionCreators
)
(PrintAlertBox)
